import React from "react"
import DynamicSelectWithSearch from "../../shared/DynamicSelectWithSearch";
import { formatValidSelect } from "../../../helpers/FormatHelper";
import { useState } from "react";
import { getCurrenciesByCustomer } from "../../../networking/NetworkingCurrencies";
import NettingCreateScreen from "./NettingSummaryScreen";
import { getNettingByID, searchNettings } from "../../../networking/NetworkingOrders";
import NewEditableGrid from "../../shared/NewEditableGrid";
import { ZoomInOutlined } from "@material-ui/icons";
import { useEffect } from "react";

const  NettingListScreen = ({customerID, customerName, settlementCurrenciesList, onChangeBuyCurrency, onNewNetting, ViewNettingDetails}) => {

    const [validations, setValidations] = useState({
        BuyCurrency: true
    });
    const [buyCurrency, setBuyCurrency] = useState('');
    const [nettings, setNettings] = useState([]);
    const [columnDetail, setColumnDetail] = useState({});

    useEffect(() => {
        if(settlementCurrenciesList && settlementCurrenciesList.length > 0)
        {  
            setBuyCurrency(settlementCurrenciesList[0].value);
            onChangeBuyCurrency(settlementCurrenciesList[0].value, settlementCurrenciesList[0].name);
            dropdownBuyCurrencyChangeHandler({value: settlementCurrenciesList[0].value, name: settlementCurrenciesList[0].name});
        }   
    },[settlementCurrenciesList]);

    const dropdownBuyCurrencyChangeHandler = async (item) => {
      if(item.value && item.value !== '')
      {
        setBuyCurrency(item.value);
        onChangeBuyCurrency(item.value, item.name);
        setValidations({...validations, BuyCurrency: true});

        const respondeNettings = await searchNettings({CustomerID: customerID, BuyCurrency: buyCurrency});
        if(respondeNettings && respondeNettings.nettings)
        {
            setNettings(respondeNettings.nettings);
            setColumnDetail(JSON.parse(respondeNettings.columnDetail));
        }
      }
      else
      {
        setNettings([]);
        setColumnDetail({});
      }
    }

    const onNew = () => {
        if(buyCurrency)
        {
            onNewNetting();
        }
        else
        {
            setValidations({...validations, BuyCurrency: false});
        }
    }

    const handleDetailsClick = async(rowData) => {
        debugger
        const responseNetting = await getNettingByID(rowData.NettingID);
        if(responseNetting && responseNetting.data && responseNetting.data.length > 0)
        {
            const netting = responseNetting.data[0];
            const nettingDetails = netting.NettingDetails ? netting.NettingDetails : [] ;

            const ordersBuy = nettingDetails.filter((o)=> o.BuySell === 'Buy');
            const ordersSell = nettingDetails.filter((o)=> o.BuySell === 'Sell');
            
            if(netting.NettingTotalBuy > netting.NettingTotalSell)
            {
                ViewNettingDetails(ordersBuy, ordersSell, 0, netting.NettingBalance);
            }
            else
            {
                ViewNettingDetails(ordersBuy, ordersSell, netting.NettingBalance, 0);
            }
        }

    }

    return (
        <div className="uk-grid">
            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Customer:'}</label>
                <input className="uk-input" id="customer-name" value={customerName} type="text" disabled={true} />
            </div>
            <div  className="uk-width-1-4 uk-form-controls">
                <label className="uk-form-label">{'Settlement Currency:'}</label>
                 <DynamicSelectWithSearch key={'set-ccy'}
                    id={'set-ccy'}
                    className={formatValidSelect(validations.BuyCurrency)}
                    data={settlementCurrenciesList}
                    placeholder='Select a currency...'
                    getValue={dropdownBuyCurrencyChangeHandler}
                    disabled={buyCurrency !== '' && buyCurrency !== null && buyCurrency !== undefined}
                    objValue={{value:buyCurrency}}/>              
            </div>
            <div  className="uk-width-1-1 uk-form-controls" style={{marginTop:'20px'}}>
                <button className="uk-button uk-button-green" onClick={onNew}>
                    {'New'}
                </button>
            </div>

            <div  className="uk-width-1-1 uk-form-controls" style={{marginTop:'20px'}}>
                <NewEditableGrid
                            data={nettings}
                            columnDetails={columnDetail}
                            isEditable={false}         
                            useIcons={true}
                            usePrintLabel={true}
                            dynamicActions={[
                                {name: 'Details', function: handleDetailsClick, isIcon: true, icon: <ZoomInOutlined /> }
                                ]}
                            />
            </div>


        </div>
    );
}

export default NettingListScreen;